// Copyright (c) 2017 Deere & Company

export const buildClaimsQueryFromParams = params => {

    if (params) {

        let dataQueryString;

        dataQueryString = `leadAccount=${params.leadAccount}&leadAccountDisplayName=${encodeURIComponent(params.leadAccountDisplayName)}&postingDateFrom=${params.postingDateFrom}&postingDateTo=${params.postingDateTo}`;

        if (params.city) {

            dataQueryString = `${dataQueryString}&city=${params.city}`;

        }

        if (params.account) {

            dataQueryString = `${dataQueryString}&account=${params.account}`;

        }

        return dataQueryString;

    }

    return '';

};

export const buildAppendQueryFromData = data => {

    let appendQuery;

    appendQuery = '';
    appendQuery += data.account ? `&account=${data.account}` : `&city=${data.city}`;
    appendQuery += `&leadAccount=${data.leadAccount}&leadAccountDisplayName=${encodeURIComponent(data.leadAccountDisplayName)}`;

    return appendQuery;

};

export const buildFilterQueryString = filter => filter ? `&unpaidFilter=${filter}` : '';



// WEBPACK FOOTER //
// ./src/reimbursement-summary/shared/services/build-query.js